import {
  EVALUATION_SENT_DIALOG_CLASS_NAME,
  EVALUATION_SENT_DIALOG_DESCRIPTION_CLASS_NAME,
} from '../../constants/dialog';
import { getItauFontFamily } from '../typography-utils';

const TITLE_FONT_SIZE = 24;
// El trazo de la X ocupa 14/24 de su caja, asi que una caja de 20px dibuja una X de ~12px.
const CLOSE_ICON_SIZE = 20;
const CONTENT_SPACING = 16;

const stackSpacing = {
  '& > .MuiStack-root > :not(style) + :not(style)': {
    marginTop: CONTENT_SPACING,
  },
};

const evaluationSentDialog = ({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 8,
    [theme.breakpoints.up('md')]: {
      width: 488,
      maxWidth: 488,
    },
  },
  '& .MuiDialogTitle-root': {
    paddingBottom: CONTENT_SPACING,
    ...stackSpacing,
  },
  '& .MuiDialogContent-root': {
    paddingBottom: 32,
    ...stackSpacing,
  },
  '& .MuiTypography-h4': {
    fontFamily: getItauFontFamily(TITLE_FONT_SIZE),
    fontSize: TITLE_FONT_SIZE,
    fontWeight: 500,
    lineHeight: '32px',
  },
  [`& .${EVALUATION_SENT_DIALOG_DESCRIPTION_CLASS_NAME}`]: {
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.gray.A500,
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
      lineHeight: '24px',
    },
  },
  '& .MuiIconButton-root': {
    top: 16,
    right: 20,
    padding: 4,
    color: theme.palette.gray.A500,
    '& .MuiSvgIcon-root': {
      fontSize: CLOSE_ICON_SIZE,
    },
  },
});

const MuiDialog = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${EVALUATION_SENT_DIALOG_CLASS_NAME}`]: evaluationSentDialog({ theme }),
    }),
  },
};

export default MuiDialog;
